import { styled, Alert } from '@mui/material';

export const AlertComponent = styled(Alert)(({ theme }) => ({
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    textAlign: 'center',
    borderRadius: 0,
    zIndex: 10000,
    color: '#fff',
    minHeight: 44,
    padding: '6px 16px',
    background: theme.palette.warning.main,
    '& .MuiAlert-icon': {
        marginLeft: 'auto',
        color: '#fff'
    },
    '& .MuiAlert-action': {
        marginLeft: 36,
        marginRight: 'auto'
    }
}));

export const AlertFloating = styled(Alert)(({ theme }) => ({
    width: 400,
    borderRadius: 16,
    color: '#fff',
    backgroundColor: theme.palette.warning.main,
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
    backdropFilter: 'blur(8px)',
    '& svg': {
        fill: '#fff'
    }
}));
